export default "__VITE_ASSET__m_VtrdQp__"